import Layout from "./components/Layout/Layout";
import About from "./pages/About/About";
import Contact from "./pages/Contact/Contact";
import Education from "./pages/Educations/Education";
import Footer from "./pages/footer/footer";
import Projects from "./pages/Projects/Projects";
import Certificates from "./pages/Certificates/Certificates";
import Techstack from "./pages/Techstack/Techstack";
import WorkExp from "./pages/workExp/WorkExp";
import ScrollToTop from "react-scroll-to-top";
import { useTheme } from "./context/ThemeContext";
import MobileNav from "./components/MobileNav/MobileNav";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  const [theme] = useTheme();

  return (
    <div className={theme === "dark" ? "dark" : ""}>
      <div className="bg-white dark:bg-[#0f0f1a] min-h-screen transition-colors duration-300 overflow-x-hidden">
        <ToastContainer
          position="bottom-right"
          theme={theme === "dark" ? "dark" : "light"}
          toastStyle={{ borderRadius: "12px" }}
        />
        <MobileNav />
        <Layout />

        {/* Sections — offset for sidebar on desktop */}
        <div className="md:pl-[210px] transition-all duration-300" id="main-content">
          <About />
          <Education />
          <WorkExp />
          <Techstack />
          <Projects />
          <Certificates />
          <Contact />
          <Footer />
        </div>
      </div>

      <ScrollToTop
        smooth
        color="#f29f67"
        style={{
          backgroundColor: "#0f0f1a",
          border: "1px solid rgba(242,159,103,0.3)",
          borderRadius: "12px",
          boxShadow: "0 4px 20px rgba(242,159,103,0.2)",
        }}
      />
    </div>
  );
}

export default App;